import useSWR from 'swr'

const WEBAPP_BASE_URL =
  process.env.NODE_ENV === 'production' &&
  process.env.APP_DEPLOY_ENV !== 'development'
    ? document.location.origin
    : 'http://localhost:6334'

async function fetchSurveyResolution(identifier) {
  const response = await fetch(
    `${WEBAPP_BASE_URL}/api/surveys/resolve/${identifier}`
  )
  if (!response.ok) {
    throw new Error('Failed to resolve survey')
  }
  return response.json()
}

export function useResolveSurveyId(identifier) {
  const { data, error, isLoading } = useSWR(
    identifier ? `survey-resolve-${identifier}` : null,
    () => fetchSurveyResolution(identifier)
  )

  return {
    surveyId: data?.id ?? null,
    publicId: data?.publicId ?? null,
    isLoading,
    error,
  }
}

export function isPublicId(id) {
  return id && !/^\d+$/.test(id)
}
